// internal-deps
import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { NativeResponsePayload, NavigationTypes } from "@swiggy-private/native-bridge";

// constants
import { CBCC_REDIRECT_URL } from "@payment-client/constants/Order";

/**
 * Redirects to CBCC client webview after payment completion
 * This is used for both success and failure cases to handle the flow in CBCC app
 * @throws {Error} If the navigation fails
 */
export function redirectToCBCC(): Promise<NativeResponsePayload | undefined> {
    return getBridgeSdk().navigateToScreen({
        type: NavigationTypes.DEEPLINK,
        link: CBCC_REDIRECT_URL,
        params: {
            shouldCloseWebview: true,
            shouldRefresh: false,
        },
    });
}
